import { axiosInstance } from "@/lib/axios";

export type SearchModel = "user" | "nft" | "collection" | "drops" | "blogs";

export type SearchParams = {
  text: string;
  count?: number;
  order?: "asc" | "desc";
  order_by?: "id" | "created_at";
  model?: SearchModel[];
};

export type SearchResultArtist = {
  id: number;
  name: string;
  username: string;
  referral_code: string;
  blue_check: number;
  profile: {
    bio: string | null;
    detail: string | null;
    links: string | null;
    cover: string | null;
    banner: string | null;
  };
  following: {
    following: number;
    follower: number;
  };
};

export type SearchResultCollection = {
  id: number;
  name: string;
  status: string;
  blue_check: number;
  contract_address: string;
  description: string;
  network_name: string;
  logo: string;
  banner: string;
  network: number;
  standard: number;
  local_user_id: number;
  created_at: string;
  updated_at: string;
  likes: {
    count: number;
  };
  current_user: {
    like: boolean;
  };
};

export type SearchResultNFT = {
  id: number;
  name: string;
  status: string;
  contract_address: string;
  collection_id: number;
  description: string;
  ipfs_address: string;
  network_name: string;
  image: string;
  token_id: number;
  network: number;
  royalty: number;
  quantity: number;
  standard: number;
  local_user_id: number;
  type: string;
  extension: string;
  ipfs_provider: string;
  created_at: string;
  updated_at: string;
  likes: {
    count: number;
  };
  current_user: {
    like: boolean;
  };
};

export type SearchResponseData = {
  artists: SearchResultArtist[];
  collections: SearchResultCollection[];
  nfts: SearchResultNFT[];
  drops: any[]; // Define properly if structure is known
  blogs: any[]; // Define properly if structure is known
};

export type SearchResponse = {
  data: SearchResponseData;
  message: string | null;
  next: string | null;
  errors: any | null;
  meta: any[];
};

export const searchGlobal = async (params: SearchParams): Promise<SearchResponse> => {
  const response = await axiosInstance.post("/search", {
    text: params.text,
    count: params.count || 5,
    order: params.order || "desc",
    order_by: params.order_by || "id",
    model: params.model || ["user", "nft", "collection", "drops", "blogs"],
  });
  return response.data;
};
